<template>
    <div id="adjustment">
        <goTop/>
        <step :stepNumber="1"/>
        <div class="content">
            <div class="container">
                <h2 class="title2">保障調整</h2>
                <attention/>
                <h3 class="blueTitle">旅客投保旅平綜合保險保障明細</h3>
                <p class="goCountry">旅遊國家 :
                    <span>台灣</span>
                </p>
                <p class="goDate">旅遊期間 : {{ pageStorage.startEndDateTime }}</p>
                <div class="attentionBox" v-if="carMotorPolicy">
                    凡加購國內租借汽車保險、國內租借機車保險任一商品，請確認是否每位被保人都需此商品，若要變更請於此頁調整。
                </div>
                <div v-for="(item, key) in adjustData" :key="key" class="form">
                    <adjustItem  :childItem="item" :childKey="key"
                                @updateRoster="calculatePrem" ref="adjustItemRef"/>
                </div>
                <div class="greenLine"></div>
                <div class="countArea">
                    <div class="notice">
                        <!--            <div class="noticeCon" v-if="pageStorage.rosters.length > 1">-->
                        <!--              <img src="../assets/attention.svg" alt="">-->
                        <!--              <p class="red">提醒您，(多人投保)需要簽回要保書唷!</p>-->
                        <!--            </div>-->
                    </div>
                    <count :key="reloadCountKey" @countComplete="countComplete"/>
                </div>
            </div>
        </div>
        <div class="btnArea">
            <router-link :to="'/count2'" class="btn pink adjust_back_accu">返回</router-link>
            <button class="btn center adjust_go_accu" @click="checkLogin" :disabled="openButton">立即投保
            </button>
        </div>
    </div>
</template>
<script setup>
        import goTop from "@/components/gotop.vue";
        import attention from "@/components/attention.vue";
        import step from "@/components/step.vue";
        import count from "@/components/count.vue";
        import adjustItem from "@/components/adjustment/adjustItem.vue";
        import {popUp} from "@/utils/popUp";
        import gtm from "@/utils/gtmDataLayer";
        import {onMounted, ref} from "vue";
        import $ from "jquery";
        import {useRouter} from "vue-router";
        import Swal from "sweetalert2";

        const router = useRouter();//轉跳router
        const pageStorage = ref(null);
        const adjustData = ref([]);
        const countDays = ref(0);
        const reloadCountKey = ref(0);
        const openButton = ref(true);
        const carMotorPolicy= ref(false);
        const plan = ref([]);
        const adjustItemRef = ref();

        const loadPageStorage = ()=>{
            pageStorage.value = JSON.parse(sessionStorage.getItem('pageStorage'));
            adjustData.value = pageStorage.value.adjustData;
            plan.value = pageStorage.value.plan;
            countDays.value = pageStorage.value.countDays ? pageStorage.value.countDays : 0;
        }
        const attentionFunc = () =>{
            const CarObject = plan.value.find(p => p.planName === "buyCarPolicy");
            const MotorObject = plan.value.find(p => p.planName === "buyMotorPolicy");
            if(CarObject.isCheck === true ||MotorObject.isCheck === true){
                carMotorPolicy.value = true;
            }else{
                carMotorPolicy.value = false;
            }
        }
        const calculatePrem = () => {
            openButton.value = true;
            reloadCountKey.value += 1;
        }
        //計算完畢
        const countComplete = ()=>{
            openButton.value = false;
            adjustItemRef.value.forEach(adjustRef => {
                adjustRef?.loadAdjustData();
                adjustRef?.loadRosterDetail();
            })
        }
        const checkLogin = () =>{
            calculatePrem();
            sendDataLayer("add_to_cart");
            Swal.fire({
                title: "重要提醒",
                confirmButtonText: "已經確認",
                cancelButtonText:"重新確認",
                reverseButtons:true,
                showCancelButton:true,
                showCloseButton:false,
                allowOutsideClick:false,
                customClass: {container: "alert80vh"},
                html: '<p><img src="noticemark.svg" alt="notice" class="noticemark"><p>'+
                    '<ul><li>若您投保的保險方案包含「限額」保障，其理賠方式為「實支實付」，<span class="red">申請理賠須提供「正本收據」</span>。</li>' +
                    '<li>發生保險事故產生實際合理支出時，<span class="red">請妥善保存正本收據</span>，以確保您的理賠權益。<span class="red">收據僅能核銷單一理賠項目</span>，除非單項保額超過，否則恕無法同時適用於多個險種。</li></ul>' +
                    '<p class="pSpace">請提前投保，並於投保前確認所選方案是否符合您的需求。感謝您的理解與配合！</p>'
            }).then((result) => {
                if (result.isConfirmed) {
                    var jwtInfo = localStorage.getItem("jwtInfo");
                    sessionStorage.setItem("bannerLogin", false);
                    if (jwtInfo != null) {
                        router.push("/detail");
                    } else {
                        router.push("/login");
                    }
                } else if (result.isDenied) {
                    Swal.close()
                }
            });
        }
        const sendDataLayer = (event) => {
            gtm.policyEvent(event, pageStorage.value.calculatePremRes.totalPremium
                , null, null, null, null
                , 'optional_taiwan', '自行試算');
        }

        //載入 pageStorage 生成頁面需使用 放在setup區域
        loadPageStorage();

        onMounted(()=>{
            gtm.pageViewEvent();//新增pageViewEvent
            popUp();//公告系統
            $("#step li:nth-of-type(1)").find(".number").addClass('active'); //設定哪個step亮黃圈
            //一定要刪的session
            sessionStorage.removeItem('fromPage');
            sessionStorage.removeItem("registerStorage");
            //無要保序號就要刪的session
            const applicationNo = sessionStorage.getItem("applicationNo");
            if (applicationNo != null) {
                let removeStorage = ['detailStorage','applicationNo','insTraOrderId','confirmPolicyType','otp'];
                removeStorage.forEach(k =>
                    sessionStorage.removeItem(k)
                )
            }
            attentionFunc();
        });

</script>
<style lang="scss">
#adjustment {
    color: $textColor;
    .mainPlan {
        border: 2px solid $blue-700;
        background: #fff;
        width: 95%;
        border-radius: 10px;
        overflow: hidden;
        margin: 30px auto;
        .planTitle {
            background: $blue-700;

            &::after {
                content: "";
                display: block;
                position: absolute;
                right: 20px;
                top: 10px;
                width: 30px;
                height: 30px;
                background-image: url(../assets/isChoose.svg);
                background-repeat: no-repeat;
            }

            input[type="checkbox"] {
                display: none;
            }
        }
        ul {
            box-sizing: border-box;
            padding: 0 20px;

            li {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: justify;
                -ms-flex-pack: justify;
                justify-content: space-between;
                line-height: 40px;
                font-weight: bold;
                padding: 3px 0;

                .inputStyle {
                    width: 40%;
                }
            }
        }
    }
    .goDate,
    .goCountry {
        margin: 10px 0
    }
    .attentionBox {
        margin-top: 40px;
    }

    .planTitle {
        background: $gray;
        box-sizing: border-box;
        padding: 10px 20px;
        position: relative;

        p {
            padding-left: 10px;
            color: #fff;
            border-left: 3px solid #fff;
            display: inline-block;
            margin-right: 5px;
        }

        &::after {
            content: "";
            display: block;
            position: absolute;
            right: 20px;
            top: 10px;
            width: 30px;
            height: 30px;
            background-image: url(../assets/add.svg);
            background-repeat: no-repeat;
        }
    }

    .planCon {
        display: none;
    }

    .choose {
        opacity: 0
    }

    .notice {
        width: 45%;
        display: flex;
        vertical-align: top;
        @media screen and (max-width: $small) {
            width: 100%;
            font-size: 15px;
        }

        p {
            margin-left: 35px;
            @media screen and (max-width: $small) {
                margin-left: 25px;
            }
        }

        img {
            width: 30px;
            position: absolute;
            @media screen and (max-width: $small) {
                width: 20px;
            }
        }

        p,
        img {
            display: inline-block
        }
    }
  .attention {
    display: block;
    background: #FFF5D9;
    border: 2px solid $yellow;
    text-align: left;
    padding: 10px;
    box-sizing: border-box;
    color: $textColor;
    font-size: 16px;
    margin:10px auto 0;
  }
}
</style>
